module.exports = "/static/assets/b5257afbe4bcf7953029ddb8f18b24fe.svg";